import createMuiTheme, { ThemeOptions } from '@material-ui/core/styles/createMuiTheme';

const themeOptions: ThemeOptions = {
  palette: {
    type: 'light',
    primary: {
      main: '#12d7d3',
    },
    secondary: {
      main: '#1185f0',
    },
    background: {
      default: '#fbfbfb',
    },
    warning: {
      main: '#ffdc2e',
    },
  },
  typography: {
    fontSize: 16,
    h1: {
      fontSize: '4rem',
    },
    h2: {
      fontSize: '3.5rem',
    },
    h3: {
      fontSize: '3rem',
    },
    h4: {
      fontSize: '2.5rem',
    },
    h5: {
      fontSize: '2rem',
    },
    h6: {
      fontSize: '1.5rem',
    },
    subtitle1: {
      fontSize: '1.2rem',
    },
    body1: {
      fontSize: '1rem',
    },
    button: {
      letterSpacing: '0.05em',
      textTransform: 'none'
    },
    overline: {
      letterSpacing: '0.1em',
    },
  },
};

export const themeFourLinux = createMuiTheme(themeOptions)